<template>
    <div>
      <Type1 :type="type" v-if="type==1"/>
      <Type2 :type="type" v-if="type==2"/>
    </div>
</template>

<script>
    import API from "./api";
    import Type1 from "./components/type1/index.vue"
    import Type2 from "./components/type2/index.vue"
    export default {
        name: "index",
      props: {
        type:{type: [String, Number],},

      },
        data() {
            return {
            }
        },
        created() {
        },
        mounted() {
        },
        components: {Type1,Type2},
        computed: {

        },
        methods: {
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
